import { Venta } from './venta';
import { Mercaderia } from './mercaderia';
import { Usuario } from './usuario';

export class DetalleVenta {
  id: number;
  venta: Venta;
  mercaderia: Mercaderia;
  usuario: Usuario;
  cantidad: number;
  precio: number;
  ganancia: number;
  descripcion: String;

  constructor() {
    this.venta = new Venta();
    this.mercaderia = new Mercaderia();
    this.usuario = new Usuario();
  }
}
